import React from 'react';
import { connect } from 'react-redux';
import classnames from 'classnames';
import { Collapse } from 'reactstrap';
import { withRouter } from 'react-router';
import { bindActionCreators } from 'redux';
import { Translate, withLocalize } from 'react-localize-redux';
import { isNullOrUndefined, openInNewWindow } from '../../../store/storeFunctions';
import { reportActions } from '../../../store/reportStore';
import ReportButtons from "../../../components/search/reportButtons";
import { QuickReportRow, rowType } from './quickReportRow';
import Map from '../../common/mapComponent';
import HistoryLink from '../../common/historyLink';
import { searchActions } from '../../../store/searchStore';
import { popupActions } from '../../../store/popupStore';
import { entityIdentRowActions } from '../../../store/entityIdentRowStore';
import { isOnPath } from '../../../store/apiWrapper';
import CustomTooltip from "../../common/customTooltip";
import MoreLink from '../../common/moreLink';
import SourceLinks from "../SourceLinks";

import { AddToPortfolioButton, WarningsButton, AddToClipboardButton, AdvancedInformationButton } from "../../common/refButtons";

import './quickReport.scss';
import QuickReportBreakRow from './quickReportBreakSection';

const mode = { names: 'desktop|mobile', buttons: 'desktop|mobile', extraData: 'desktop|mobile', basicLink: 'desktop|mobile' };
const showReports = isOnPath({ regex: /\/unlimited\//i });

class QuickReport extends React.Component {

    state = {
        namesHistoryExpanded: false,
        addressHistoryExpanded: false,
        namesHistoryTouched: false,
        addressHistoryTouched: false,
        isExpandedPrimaryNamesTouched: false,
        isExpandedUngroupedNamesTouched:false
    };

    componentDidMount() {
        if (showReports) {
            this.props.ensureEntityInfo(this.props.report.id);
        }
    }

    componentDidUpdate(prevProps) {
        if (this.props.isExpandAllActivated !== prevProps.isExpandAllActivated || this.props.isHideAllActivated !== prevProps.isHideAllActivated)
            this.setState({ namesHistoryTouched: false, addressHistoryTouched: false, isExpandedPrimaryNamesTouched: false, isExpandedUngroupedNamesTouched: false });

        if (prevProps.report.id !== this.props.report.id && showReports) {
            this.props.ensureEntityInfo(this.props.report.id);
        }
    }

    render() {
        if (isNullOrUndefined(this.props.data))
            return null;
        if (isNullOrUndefined(this.props.data.name))
            return null;
        if (this.props.data.isCompany && isNullOrUndefined(this.props.data.companyData))
            return null;
        if (!this.props.data.isCompany && isNullOrUndefined(this.props.data.personData))
            return null;

        if (showReports) {
            if (!(this.props.report.id &&
                this.props.entityInfos[this.props.report.id] &&
                !this.props.entityInfos[this.props.report.id].isLoading &&
                this.props.entityInfos[this.props.report.id].result))
                return null;
        }

        return this.renderWithData(this.props.data);
    }

    renderWithData = (data) => {
        let test = this.props.entityInfos[this.props.report.id];
        return (
            <div className="columns">
                <div className="column is-12-desktop">
                    <table className="table table-report-section key-value">
                        <colgroup>
                            <col width="30%" />
                            <col width="70%" />
                        </colgroup>
                        <tbody>
                            {data.isCompany ? this.renderCompanyData(data) : this.renderPersonData(data)}
                        </tbody>
                    </table>
                    {showReports &&
                        <React.Fragment>
                            {this.otherIcons(this.props.entityInfos[this.props.report.id].result)}
                            {this.otherReports(this.props.entityInfos[this.props.report.id].result)}
                        </React.Fragment>}
                    {this.renderAdvancedInfo(this.props.entityInfos[this.props.report.id].result)}
                    {<SourceLinks sourceLinks={data.links} />} 
                </div>
            </div>
        )
    }

    otherIcons = (data) => {
        return (
            <div className="qs-report-buttons" style={{ display: 'flex' }}>
                {data.reports.NI && <WarningsButton link={`/warnings/${data.entityId}`} showOnMobile={true} />}
                <AddToPortfolioButton onClick={() => this.openPortfolioPopup(data)} showOnMobile={true} />                
                <AddToClipboardButton entityId={data.entityId} onAdd={() => this.props.addToClipboard(data, this.props.translate('Search.Clipboard.SubjectAdded'))}
                    onRemove={() => this.props.removeFromClipboard(data, this.props.translate('Search.Clipboard.SubjectRemoved'))} showOnMobile={true} />
            </div>
        )

    }

    renderAdvancedInfo = (data) => {
        return(
            <>
                <span className={classnames("qs-links-label", {"no-padding": !showReports})}><Translate id="Report.CheckSubject" /></span>
                <AdvancedInformationButton links={true} entityInfo={data} id={"AdvancedInformationButton"} showOnMobile={true} />
            </>
        );
    }

    openPortfolioPopup = (subject) => {
        this.props.showPopup("addToPortfolioPopup", {
            open: true,
            subject,
            ok: () => { },
            close: () => { this.props.hidePopup(); }
        })
    }

    otherReports = (data) => {
        return (
            <ReportButtons entityInfo={data} mode={mode} useShort={false} maxTableWidth={this.props.maxTableWidth} style={{ marginTop: '.25em' }} />
        )
    }

    renderCompanyData = (data) => {
        const hasHistoricalNames = !isNullOrUndefined(data.historicalNames) && data.historicalNames.length > 0;
        const hasActualAddresses = !isNullOrUndefined(data.actualAddresses) && data.actualAddresses.length > 0;
        const hasHistoricalAddresses = !isNullOrUndefined(data.historicalAddresses) && data.historicalAddresses.length > 0;
        const hasNaceItems = !isNullOrUndefined(data.companyData.primaryNaceItems) && data.companyData.primaryNaceItems.length > 0;

        return (
            <React.Fragment>
                {!isNullOrUndefined(data.name.name) && <tr>
                    <td><Translate id={`Report.Quick.Company.${data.isFop ? 'Fop' : ''}Name`} /></td>
                    <td>
                        <div className="qr-flex">
                            <div style={{width:'68%'}}>
                                <span className="bold-text">{data.name.name}</span><span>
                                { data.name.nameFrom != null && <span className="small" style={{display: 'inline-block'}}>&nbsp;{`(`}<Translate id="Report.Common.From" />&nbsp;{data.name.nameFrom})</span>}
                                </span>
                                &nbsp;
                                {(data.primaryNames != null && data.primaryNames.length > 0) && <span className="link-functional print-hidden flex"
                                                onClick={() => this.setState({
                                                expandedPrimaryNames: !this.props.resolveExpanded(this.state.expandedPrimaryNames, this.state.isExpandedPrimaryNamesTouched),
                                                isExpandedPrimaryNamesTouched: true
                                            })} >
                                    <MoreLink noWrapper moreExpanded={this.props.resolveExpanded(this.state.expandedPrimaryNames, this.state.isExpandedPrimaryNamesTouched)} />
                                </span>}
                            </div>

                            <div style={{width:'32%'}}>
                                <span className="src" id ="namesId"  style={{ alignSelf: "flex-end", marginLeft: 'auto', float: 'right' }}>
                                    ({this.props.translate("Report.Common.Source").toLowerCase()}:&nbsp;{data.name.source})
                                    <CustomTooltip textAlign="right" placement='left' id="namesId" text={data.name.SourceFull} hideIcon delay={{ "show": 0, "hide": 0 }} innerClassName='tooltipSection'>
                                    </CustomTooltip>
                                </span>
                            </div>
                        </div>

                        <Collapse className="normal-row" isOpen={this.props.resolveExpanded(this.state.expandedPrimaryNames, this.state.isExpandedPrimaryNamesTouched)}>
                            {data.primaryNames.map(n =>
                                <div key={n.id}>
                                    <div className="qr-flex">
                                        <div style={{width:'68%'}}>
                                            <span>
                                                <span>{n.name}</span>
                                                <span  className="small">
                                                ({this.props.translate("Report.Common.From").toLowerCase()}&nbsp;{n.fromFormated}{")"}
                                                </span>
                                            </span>
                                        </div>
                                        <div style={{width:'32%'}}>
                                            <span className="src" id={`primaryNamesId-`+n.id} style={{ alignSelf: "flex-end", marginLeft: 'auto', float: 'right' }}>
                                                ({this.props.translate("Report.Common.Source").toLowerCase()}:&nbsp;{n.source})
                                                <CustomTooltip textAlign="right" placement='left' id={`primaryNamesId-` + n.id} text={n.SourceFull} hideIcon delay={{ "show": 0, "hide": 0 }} innerClassName='tooltipSection'>
                                                </CustomTooltip>   
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </Collapse>

                        {hasHistoricalNames && 
                        <div>
                            <span className="link-functional" onClick={this.toggleNamesHistory}>
                                <HistoryLink historyExpanded={this.props.resolveExpanded(this.state.namesHistoryExpanded, this.state.namesHistoryTouched)} noWrapper />
                            </span>
                            <Collapse className="qr-history" isOpen={this.props.resolveExpanded(this.state.namesHistoryExpanded, this.state.namesHistoryTouched)}>
                                {data.historicalNames.map((n, i) =>
                                    <div key={n.id}>
                                        <div className="qr-flex">
                                            <div style={{width:'68%'}}>
                                                <span>{n.name}</span>
                                                <span>
                                                    ({this.props.translate("Report.Common.From").toLowerCase()}&nbsp;{n.fromFormated}
                                                    {", "}
                                                    {this.props.translate("Report.Common.To").toLowerCase()}&nbsp;{n.toFormated})
                                                </span>
                                                {(data.primaryNamesUngrouped != null && data.primaryNamesUngrouped.length > 0 && data.historicalNames.length - 1 == i) && 
                                                    <span className="link-functional print-hidden"
                                                    onClick={() => this.setState({
                                                    expandedUngroupedNames: !this.props.resolveExpanded(this.state.expandedUngroupedNames, this.state.isExpandedUngroupedNamesTouched),
                                                    isExpandedUngroupedNamesTouched: true })}>
                                                    <MoreLink noWrapper moreExpanded={this.props.resolveExpanded(this.state.expandedUngroupedNames, this.state.isExpandedUngroupedNamesTouched)} />
                                                </span>}
                                            </div>
                                            <div style={{width:'32%'}}>
                                                <span className="src" id={`namesHistoryId-`+n.id} style={{  alignSelf: "flex-end", marginLeft: 'auto', float: 'right' }}>
                                                    ({this.props.translate("Report.Common.Source").toLowerCase()}:&nbsp;{n.source})
                                                    <CustomTooltip textAlign="right" placement='left' id={`namesHistoryId-` + n.id} text={n.SourceFull} hideIcon delay={{ "show": 0, "hide": 0 }} innerClassName='tooltipSection'>
                                                    </CustomTooltip>   
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </Collapse>

                            <Collapse className="qr-history" isOpen={this.props.resolveExpanded(this.state.expandedUngroupedNames, this.state.isExpandedUngroupedNamesTouched)}>
                                <span className="history-row"><span className="id-name bold-name" style={{fontWeight: 'bold'}}><Translate id="MarketingList.Common.UngroupedNamesSection"/></span></span>
                                
                                {data.primaryNamesUngrouped.map((n, i) =>
                                    <div key={n.id}>
                                        <div className="qr-flex">
                                            <div style={{width:'68%'}}>
                                                <span>
                                                    <span>{n.name}</span>
                                                    <span>
                                                        ({this.props.translate("Report.Common.From").toLowerCase()}&nbsp;{n.fromFormated}{")"}
                                                    </span>
                                                </span>
                                            </div>
                                            <div style={{width:'32%'}}>
                                                <span className="src" id={`ungrouped-`+n.id} style={{ alignSelf: "flex-end", marginLeft: 'auto', float: 'right' }}>
                                                    ({this.props.translate("Report.Common.Source").toLowerCase()}:&nbsp;{n.source})
                                                    <CustomTooltip textAlign="right" placement='left' id={`ungrouped-` + n.id} text={n.SourceFull} hideIcon delay={{ "show": 0, "hide": 0 }} innerClassName='tooltipSection'>
                                                    </CustomTooltip>   
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </Collapse>
                        </div>}
                    </td>
                </tr>}
                <QuickReportRow translationKey="Report.Quick.Company.ID" value={data.companyData.companyId} />
                <QuickReportRow translationKey="Report.Quick.Company.TaxID" value={data.companyData.taxId} />
                <QuickReportRow translationKey="Report.Quick.Company.VatID" value={data.companyData.vatId} />
                {data.companyData.companyTaxNumber && data.companyData.companyTaxNumber.SourceId == "DU" && <QuickReportRow translationKey="Report.CompanyIdentification.VatId" value={data.companyData.companyTaxNumber.TaxNumber + " " + this.props.translate("Report.CompanyIdentification.VatIdForeign")} />}
                {data.companyData.companyTaxNumber && data.companyData.companyTaxNumber.SourceId == "00" && <QuickReportRow translationKey="Report.CompanyIdentification.VatId" value={data.companyData.companyTaxNumber.TaxNumber + " " + this.props.translate("Report.CompanyIdentification.VatIdIdentified")} />}
                <tr>
                    <td style={{ verticalAlign: "top" }}><Translate id="Report.Quick.Company.RegisteredSeat" /></td>
                    <td>
                        {hasActualAddresses && <div>
                            {data.actualAddresses.map(a =>
                                <div key={a.id} className="qr-flex">
                                    <span>
                                        {a.address}&nbsp;                                                
                                        <span  className="small">
                                            ({this.props.translate("Report.Common.From").toLowerCase()}&nbsp;{a.fromFormated}{")"}
                                        </span>
                                        <Map id={a.id} address={a.address} />
                                    </span>
                                    <span className="src" id={`addrId-`+a.id}>
                                        ({this.props.translate("Report.Common.Source").toLowerCase()}:&nbsp;{a.source})
                                        <CustomTooltip textAlign="right" placement='left' id={`addrId-` + a.id} text={a.SourceFullName} hideIcon delay={{ "show": 0, "hide": 0 }} innerClassName='tooltipSection'>
                                                </CustomTooltip>   
                                    </span>
                                </div>
                            )}
                        </div>}
                        {hasHistoricalAddresses && <div>
                            <span className="link-functional" onClick={this.toggleAddressHistory}>
                                <HistoryLink historyExpanded={this.props.resolveExpanded(this.state.addressHistoryExpanded, this.state.addressHistoryTouched)} noWrapper />
                            </span>
                            <Collapse className="qr-history" isOpen={this.props.resolveExpanded(this.state.addressHistoryExpanded, this.state.addressHistoryTouched)}>
                                {data.historicalAddresses.map(a =>
                                    <div key={a.id}>
                                        <div className="qr-flex">
                                            <span>
                                                {a.address};
                                                <Map id={a.id} address={a.address} />
                                            </span>
                                            <span className="src"  id={`historyAddrId-`+a.id}>
                                                ({this.props.translate("Report.Common.Source").toLowerCase()}:&nbsp;{a.source})
                                                <CustomTooltip textAlign="right" placement='left' id={`historyAddrId-` + a.id} text={a.SourceFullName} hideIcon delay={{ "show": 0, "hide": 0 }} innerClassName='tooltipSection'>
                                                </CustomTooltip>   
                                            </span>
                                        </div>
                                        <div className="small">
                                            <span className="italic-text">
                                                ({this.props.translate("Report.Common.From").toLowerCase()}&nbsp;{a.fromFormated}
                                                {", "}
                                                {this.props.translate("Report.Common.To").toLowerCase()}&nbsp;{a.toFormated})
                                            </span>
                                        </div>
                                    </div>
                                )}
                            </Collapse>
                        </div>}
                    </td>
                </tr>
                <QuickReportRow translationKey="Report.Quick.Company.Web" value={data.companyData.web} type={rowType.link} />
                <QuickReportRow translationKey="Report.Quick.Company.Created" value={data.companyData.creationDateFormated} />
                <QuickReportRow translationKey="Report.Quick.Company.Dissolved" value={data.companyData.dissolutionDateFormated} />
                <QuickReportRow translationKey="Report.Quick.Company.BasicCapital" value={data.companyData.basicCapital}
                    type={rowType.money} currency={data.companyData.basicCapitalCurrency} />
                {hasNaceItems > 0 && <tr>
                    <td style={{ verticalAlign: "top" }}><Translate id="Report.Quick.Company.Nace" /></td>
                    <td>
                        {data.companyData.primaryNaceItems.map((n, i) =>
                            <div key={`${n.id}_${n.source.replace(' ', '-')}`} className="qr-flex">
                                <span>{n.value}</span>
                                <span className="src" id={`naceId-`+n.id+i}>
                                    ({this.props.translate("Report.Common.Source").toLowerCase()}:&nbsp;{n.source})
                                    <CustomTooltip textAlign="right" placement='left' id={`naceId-`+n.id+i} text={n.SourceFull} hideIcon delay={{ "show": 0, "hide": 0 }} innerClassName='tooltipSection'>
                                                </CustomTooltip>  
                                </span>
                            </div>)}
                    </td>
                </tr>}
                <QuickReportRow translationKey="Report.Quick.Company.TurnoverRange" value={data.companyData.turnoverRange} />
                <QuickReportRow translationKey="Report.Quick.Company.EmployeesRange" value={data.companyData.employeesRange} />
                <QuickReportRow translationKey="Report.Quick.Company.BusinessCreation" value={data.companyData.businessCreationFormated} />
                <QuickReportBreakRow translationKey="Report.TradeInterruptions" value={data.companyData.tradeInterruptions} breakStart={data.companyData.breakStartFormated} breakEnd={data.companyData.breakEndFormated}/>
                <QuickReportRow translationKey="Report.Quick.Company.BusinessExpiration" value={data.companyData.businessExpiryFormated} />

                <QuickReportRow translationKey="Report.Quick.Company.LastUpdate" value={data.companyData.lastUpdateFormated} />
                <QuickReportRow translationKey="Report.Quick.Company.LastFinStatementUpdate" value={data.companyData.lastFinStatementUpdateFormated} />
                <QuickReportRow translationKey="Report.Quick.Company.LastTradeRegisterUpdate" value={data.companyData.lastTradeRegisterUpdateFormated} />
            </React.Fragment>
        )
    }

    renderPersonData = (data) => {
        const hasActualAddresses = !isNullOrUndefined(data.actualAddresses) && data.actualAddresses.length > 0;
        const hasHistoricalAddresses = !isNullOrUndefined(data.historicalAddresses) && data.historicalAddresses.length > 0;
        const prefix = isNullOrUndefined(data.personData.prefixTitles) ? null : `${data.personData.prefixTitles.trim()} `;
        const suffix = isNullOrUndefined(data.personData.suffixTitles) ? null : ` ${data.personData.suffixTitles.trim()}`;
        const fullName = `${prefix}${data.name.name}${suffix}`;

        return (
            <React.Fragment>
                {!isNullOrUndefined(data.name.name) && <tr>
                    <td><Translate id="Report.Quick.Person.Name" /></td>
                    <td>
                        <div className="qr-flex">
                            <span className="bold-text">{data.name.name}</span>
                            <span className="src">
                                ({this.props.translate("Report.Common.Source").toLowerCase()}:&nbsp;{data.name.source})
                            </span>
                        </div>
                    </td>
                </tr>}
                <QuickReportRow translationKey="Report.Quick.Person.DateOfBirth" value={data.personData.birthDateFormated} type={rowType.string} className={"bold-text"} />
                <tr>
                    <td style={{ verticalAlign: "top" }}><Translate id="Report.Quick.Company.RegisteredSeat" /></td>
                    <td>
                        {hasActualAddresses && <div>
                            {data.actualAddresses.map(a =>
                                <div key={a.id} className="qr-flex">
                                    <span>
                                        {a.address}&nbsp;
                                        <Map id={a.id} address={a.address} />
                                    </span>
                                    <span className="src">
                                        ({this.props.translate("Report.Common.Source").toLowerCase()}:&nbsp;{a.source})
                                    </span>
                                </div>
                            )}
                        </div>}
                        {hasHistoricalAddresses && <div>
                            <span className="link-functional" onClick={this.toggleAddressHistory}>
                                <HistoryLink historyExpanded={this.props.resolveExpanded(this.state.addressHistoryExpanded, this.state.addressHistoryTouched)} noWrapper />
                            </span>
                            <Collapse className="qr-history" isOpen={this.props.resolveExpanded(this.state.addressHistoryExpanded, this.state.addressHistoryTouched)}>
                                {data.historicalAddresses.map(a =>
                                    <div key={a.id}>
                                        <div className="qr-flex">
                                            <span>
                                                {a.address};
                                                <Map id={a.id} address={a.address} />
                                            </span>
                                            <span className="src">
                                                ({this.props.translate("Report.Common.Source").toLowerCase()}:&nbsp;{a.source})
                                            </span>
                                        </div>
                                        <div className="small">
                                            <span className="italic-text">
                                                ({this.props.translate("Report.Common.From").toLowerCase()}&nbsp;{a.fromFormated}
                                                {", "}
                                                {this.props.translate("Report.Common.To").toLowerCase()}&nbsp;{a.toFormated})
                                            </span>
                                        </div>
                                    </div>
                                )}
                            </Collapse>
                        </div>}
                    </td>
                </tr>
            </React.Fragment>
        )
    }

    toggleNamesHistory = () => {
        this.setState({
            namesHistoryExpanded: !this.props.resolveExpanded(this.state.namesHistoryExpanded, this.state.namesHistoryTouched),
            namesHistoryTouched: true
        });
    }

    toggleAddressHistory = () => {
        this.setState({
            addressHistoryExpanded: !this.props.resolveExpanded(this.state.addressHistoryExpanded, this.state.addressHistoryTouched),
            addressHistoryTouched: true
        });
    }
}

export default withLocalize(withRouter(connect(
    state => ({ ...state.entityIdentRow, report: state.report, user: state.userContext }),
    dispatch => bindActionCreators({ ...entityIdentRowActions, ...reportActions, ...popupActions, ...searchActions }, dispatch)
)(QuickReport)));